import { Component, Inject, Input, OnChanges, Optional } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ViewerData {
  title?: string;
  url: string;
  type: string;
}

@Component({
  selector: 'app-pdfviewer',
  templateUrl: './pdfviewer.component.html',
  styleUrls: [ './pdfviewer.component.scss' ]
})
export class PDFViewerComponent implements OnChanges {

  @Input() dataViaInput: ViewerData;

  public doc: any;
  public isLoading: boolean = false;

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: ViewerData
  ) {
    this.isLoading = true;
    if ((this.data && !this.data.type) || (this.dataViaInput && !this.dataViaInput.type)) {
      this.data.type = 'PDF';
    }
  }

  ngOnChanges(): void {
    if (this.dataViaInput) {
      this.data = this.dataViaInput;
    }
  }

  download(): void {
    window.open(this.data.url || this.dataViaInput.url, '_blank');
  }
}
